module.exports = __webpack_public_path__ + "static/media/linkedin.a5e9e8cb.svg";